import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a331c174"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "iphone_img"
};
const _hoisted_2 = {
  class: "iphone_img_content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preface"
}, " 为保障相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方服务商提供的软件开发包（SDK）、应用程序接口（API）、应用程序插件等代码或通过其他合作方式，以实现相关目的。第三方服务商对您信息具体的处理情况请参见其隐私政策或服务协议。请注意，第三方服务商代码可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。以下是我们接入的主要的第三方服务商的信息： ", -1));

const _hoisted_4 = {
  class: "font_bolr sdk_title"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font_bolr"
}, "涉及个人信息:", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "使用目的：", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "使用场景：", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "采集方式：", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "合作方主体：", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "合作方隐私链接：", -1));

const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_bolr"
}, "合作方官网链接：", -1));

const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "card_list",
      key: index
    }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_hoisted_5, _createElementVNode("p", null, _toDisplayString(item.involve_personal_info), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_6, _createTextVNode(" " + _toDisplayString(item.use_purpose), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_7, _createTextVNode(" " + _toDisplayString(item.use_scene), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_8, _createTextVNode(_toDisplayString(item.collect_type), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_9, _createTextVNode(_toDisplayString(item.company_subject), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_10, item.secrecy_link ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "go_url",
      onClick: $event => $options.goUrl(item.secrecy_link)
    }, _toDisplayString(item.secrecy_link), 9, _hoisted_11)) : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.secrecy_link), 1))])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_13, item.official_link ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "go_url",
      onClick: $event => $options.goUrl(item.official_link)
    }, _toDisplayString(item.official_link), 9, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.official_link), 1))])])]);
  }), 128))])])])]);
}